import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';

import { Roles } from 'roles';
import { Reactive } from '../common/Reactive.mixin.js';
import { PlaceSchema, Places } from '../../collections/flights/places';

import {
  Button,
  Breadcrumb,
  BPanel
} from '@sketchpixy/rubix';

import MgfTableComponent from '../common/mgfTable';

@Reactive({
	subscriptions: ["places"],
	places: Places.find({}),
})
export default class PlaceListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Places
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des places
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						{ Roles.userHasPermission(Meteor.userId(), 'places.insert') &&
							<Link to="/places/add"><Button bsStyle="success">Ajouter</Button></Link> }
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des places">
					{ this.props.isReady && 
						<MgfTableComponent fields={PlaceSchema._schema} list={this.props.places} type='places' subtype='flights'></MgfTableComponent> }
				</BPanel>
			</div>
		);
	}
}

PlaceListPage.propTypes = {
  places: React.PropTypes.array.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/places/PlaceList.page.js
 **/